module.exports = __webpack_public_path__ + "img/ma3_marzo19.7e9a402d.jpg";